const entity = 'events'
const entitySingle = 'event'
const tableIcon = 'cil-dollar'

export {
  entity,
  entitySingle,
  tableIcon
}
